module.exports = __webpack_public_path__ + "img/gobierno_senado.b7b9a789.jpg";